/* eslint-disable complexity, sonarjs/cognitive-complexity, max-lines */
/* eslint-disable max-statements */
/* eslint-disable no-underscore-dangle */
// 9fbef606107a605d69c0edbcd8029e5d
import { all, call, takeLatest, put, select, delay, fork } from 'redux-saga/effects';
import {
  isCanada,
  fireEnhancedEcomm,
  getSessionStorage,
  setSessionStorage,
  isClient,
  getIsExtendedPreorder,
  parseBoolean,
} from '@tcp/core/src/utils';
import { getUserId } from '@tcp/core/src/components/features/account/User/container/User.selectors';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getPromotionsData } from '@tcp/core/src/components/common/organisms/Promotions/container/Promotions.selectors';
import { getAccessoriesData } from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.selectors';
import {
  getProductInfo,
  getIsOutfitsOnBag,
} from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import { trackClickWithData } from '@tcp/core/src/analytics/actions';
import { setProp } from '@tcp/core/src/analytics/utils';
import { getClickAnalyticsData, getPageData } from '@tcp/core/src/analytics/Analytics.selectors';
import { fetchAbTestData } from '@tcp/core/src/components/common/molecules/abTest/abTest.actions';
import {
  setLoaderState,
  setGhostLoaderState,
  setGhostLoaderStateComplete,
} from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import {
  updateOnHoldCoupons,
  updateExpiredCoupons,
} from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.actions';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import Constants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import {
  getIsSuppressGetOrderDetails,
  getIsAvoidGetOrderDetails,
  getABTestAddToBagDrawer,
  getCartsSessionStatus,
  getOptimisticAddBagModal,
  getIsSingleAddToBagAPIEnabled,
  getIsPersistPointsApiEnabled,
  getIsBundleTrackerEnabled,
  getExtendedPreOrderValue,
  getIsHideOriginalPriceAndMarchantTagEnabled,
  getcouponOnHoldNewDesign,
  getIsApplyCheckboxPromoOnPDPEnabled,
  getIsSupressATBModalOnBag,
  getNewGlobalErrorMessage,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import {
  getPageName,
  getCartOrderList,
} from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors';
import {
  simulateLoyaltyDetail,
  updateLoyaltyPoints,
} from '@tcp/core/src/components/features/CnC/LoyaltyBanner/container/Loyalty.actions';
import InjectLoyaltyDynamicStore from '@tcp/core/src/components/features/CnC/LoyaltyBanner/container/LoyaltyDynamicStore';

import { MULTI_PACK_TYPE } from '@tcp/core/src/components/common/molecules/ProductAddToBag/container/ProductAddToBag.config';
import { getBagAnalyticsData } from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.selectors';
import { getBundleData } from '@tcp/core/src/components/common/atoms/BundleTracker/container/BundleTracker.selector';
import { setCD66 } from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgain.actions';
import { setCD81 } from '@tcp/core/src/components/features/account/BirthdayModule/container/BirthdayModule.actions';
import { getOriginalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import { setLoyaltyOrderItemPoints } from '@tcp/core/src/reduxStore/actions/customerLoyalty.actions';
import {
  getSelectedAccessories,
  getSecondarySelectedAccessories,
} from '../../../../common/molecules/Accessories/container/Accessories.selectors';
import { setCartsSessionStatus } from '../../../../../reduxStore/actions';
import { toggleCheckoutRouting } from '../../Checkout/container/Checkout.action';
import ADDEDTOBAG_CONSTANTS from '../AddedToBag.constants';
import {
  addCartEcomItem as addItemToCart,
  addCartBopisItem,
  addMultipleProductsInEcom,
  addMultipleProductsInEcomNEWAPI,
} from '../../../../../services/abstractors/SFCC/AddedToBag';
import { getLoyaltyOrderItemPoints } from '../../../../../services/abstractors/SFCC/getLoyaltyOrderItemPoints';
import {
  AddToCartError,
  AddToCartMultipleItemError,
  AddToCartOutfitItemError,
  setAddedToBagBtnLoader,
  clearAddToCartMultipleItemErrorState,
  SetAddedToBagData,
  setAddedToBagDataLocal,
  openAddedToBag,
  clearAddToBagErrorState,
  clearAddToPickupErrorState,
  AddToPickupError,
  setAddedToBagButton,
  setOutfitCarouselAddedButton,
  addedTobagMsg,
  setLoyaltyABTestFlag,
  setMultipackProductType,
  setIsMultipackItem,
  setBagAnalytics,
  setFbtComplete,
  setAddToCartFbtError,
  clearAddToCartFbtError,
  updateAddToBagInProgress,
  setOfferPriceLoadingState,
  setUnavailableProductIds,
  setInventoryUnavailable,
} from './AddedToBag.actions';
import BAG_PAGE_ACTIONS, { updateMiniBagFlag } from '../../BagPage/container/BagPage.actions';
// eslint-disable-next-line import/no-cycle
import {
  processMutationCachedDataSaga,
  processMutationNonCachedDataSaga,
} from '../../BagPage/container/BagPage.saga';
import BagPageSelectors from '../../BagPage/container/BagPage.selectors';
import BAGPAGE_CONSTANTS from '../../BagPage/BagPage.constants';
import { getAPIConfig } from '../../../../../utils';
import { getIsGuest } from '../../../account/User/container/User.selectors';
import { navigateXHRAction } from '../../../account/NavigateXHR/container/NavigateXHR.action';
import { getCartItemCount } from '../../../../../utils/cookie.util';

import { getAddedToBagGhostLoaderCompleteState } from './AddedToBag.selectors';
import { getCache } from '../../../../../utils/cache.util';
import { getMultiPackStyleType } from '../views/AddedToBag.utils';
import { setBundleData } from '../../../../common/atoms/BundleTracker/container/BundleTracker.actions';
import { saveUserbrowseSelectionApi } from '../../../../../services/abstractors/productListing/userbrowsehistory';
import { filterItems } from './AddedToBag.utils';
import { callItemInBag } from '../../../browse/BundleProduct/container/BundleProduct.actions';
import {
  getAppliedCouponsOnPDP,
  getMemoisedCouponMap,
  getRemovedPromotionsOnPdp,
} from '../../../../common/organisms/Promotions/container/Promotions.selectors';
import {
  resetAppliedPromotions,
  resetRemovedPromotions,
  setUpdateCheckbox,
} from '../../../../common/organisms/Promotions/container/Promotions.action';
import {
  checkIfCouponApplied,
  checkIfCouponRemoved,
  handleError,
} from '../../../../common/organisms/Promotions/utils/util';
import {
  applyCoupon,
  removeCoupon,
} from '../../common/organism/CouponAndPromos/container/Coupon.saga';
import { closeQuickViewModal } from '../../../../common/organisms/QuickViewModal/container/QuickViewModal.actions';
import { removeAddedProducts } from '../../../browse/DesignYourBag/container/DesignYourBag.actions';

const {
  updateCartCount,
  setOrderId,
  updateCartPriceData,
  updateOrderTypeData,
  resetBagLoadingState,
  getOrderDetails,
  setCartUpdateComplete,
} = BAG_PAGE_ACTIONS;

const fileName = 'AddedToBag.saga.js';

const getDefaultError = (err, errorMapping) => {
  return (
    (err && err.errorCode && errorMapping[err.errorCode]) ||
    (err && err.errorMessage && err.errorMessage._error) ||
    (err && err.errorCodes && errorMapping[err.errorCodes]) ||
    (errorMapping && errorMapping.DEFAULT) ||
    'ERROR'
  );
};

export const getErrorMessage = (err, errorMapping, originPage) => {
  if (
    err &&
    err.errorCodes === ADDEDTOBAG_CONSTANTS.API_CANT_RESOLVE_FFMCENTER &&
    err.errorMessageParam &&
    Array.isArray(err.errorMessageParam)
  ) {
    let errorAvailString;
    const errorMessageParamArray = err.errorMessageParam;
    if (errorMessageParamArray) {
      errorAvailString = errorMessageParamArray.filter((errorItem) => {
        return errorItem && errorItem.includes('=');
      });
    }

    const errorAvailStringValue = errorAvailString && errorAvailString[0];
    const inAvailQuantity = errorAvailStringValue && errorAvailStringValue.split('=')[1];
    const inAvailQuantityValue = parseInt(inAvailQuantity, 10);
    if (inAvailQuantityValue <= 0) {
      return errorMapping && errorMapping[ADDEDTOBAG_CONSTANTS.API_CANT_RESOLVE_FFMCENTER_OOS];
    }
    if (inAvailQuantityValue > 0) {
      return `${
        errorMapping &&
        errorMapping[ADDEDTOBAG_CONSTANTS.API_CANT_RESOLVE_FFMCENTER_PARTIAL_INSTOCK_MSG1]
      } ${inAvailQuantity} ${
        errorMapping &&
        errorMapping[ADDEDTOBAG_CONSTANTS.API_CANT_RESOLVE_FFMCENTER_PARTIAL_INSTOCK_MSG2]
      }`;
    }
  }

  if (
    err &&
    (err.errorCodes === ADDEDTOBAG_CONSTANTS.API_CANT_RESOLVE_FFMCENTER ||
      err.errorCodes === ADDEDTOBAG_CONSTANTS.BOSS_BOPIS_QUANTITY_UNAVAILABLE ||
      err.errorCodes === ADDEDTOBAG_CONSTANTS.PRODUCT_QUANTITY_UNAVAILABLE ||
      err.errorCodes === ADDEDTOBAG_CONSTANTS.ECOM_QUANTITY_UNAVAILABLE)
  ) {
    return originPage === 'shopping bag'
      ? errorMapping && errorMapping[ADDEDTOBAG_CONSTANTS.API_CANT_RESOLVE_FFMCENTER]
      : errorMapping && errorMapping[ADDEDTOBAG_CONSTANTS.API_CANT_RESOLVE_FFMCENTER_SHORT];
  }
  return getDefaultError(err, errorMapping);
};

const getCM2Event = () => {
  try {
    let analyticSV = getSessionStorage('AnalyticsObj');
    analyticSV = typeof analyticSV === 'object' ? JSON.stringify(analyticSV) : analyticSV;
    const analyticsObj = (analyticSV && analyticSV.length && JSON.parse(analyticSV)) || {};
    const { metric2 } = analyticsObj;
    if (!metric2) {
      setSessionStorage({
        key: 'AnalyticsObj',
        value: JSON.stringify({ ...analyticsObj, metric2: true }),
      });
      return { cm2: '1' };
    }
    return { cm2: '0' };
  } catch (e) {
    const analyticsObj = getSessionStorage('AnalyticsObj');
    logger.error('Error Occured in getCM2Event', {
      error: e,
      extraData: {
        component: 'AddedToBagSaga',
        parsedObj: analyticsObj,
      },
    });
    return {};
  }
};

export const getMpackTgas = (
  multiPackProductType,
  originPage,
  selectedMultipack,
  productName,
  sku
) => {
  let mpackTags = {};
  let cd124 = '';
  const cd125 = `${selectedMultipack}${ADDEDTOBAG_CONSTANTS.GA_ANAYTICS.PACK}`;
  const cd199 = getMultiPackStyleType(multiPackProductType);
  const gaAnalyticsConfKey = 'GA_ANAYTICS';
  if (multiPackProductType) {
    switch (originPage) {
      case 'pdp':
        cd124 =
          multiPackProductType === MULTI_PACK_TYPE.MULTIPACK
            ? ADDEDTOBAG_CONSTANTS[gaAnalyticsConfKey].PDP_MULTIPACK
            : ADDEDTOBAG_CONSTANTS[gaAnalyticsConfKey].PDP_SINGLE;
        break;
      case 'spdp':
        cd124 = ADDEDTOBAG_CONSTANTS[gaAnalyticsConfKey].SEARCH_PDP_MPACK;
        break;
      case 'slp':
        cd124 = ADDEDTOBAG_CONSTANTS[gaAnalyticsConfKey].SLP_MPACK;
        break;
      case 'plp':
        cd124 = ADDEDTOBAG_CONSTANTS[gaAnalyticsConfKey].PLP_MPACK;
        break;
      default:
        break;
    }
    mpackTags = {
      dimension124: cd124,
      dimension125: cd125,
      dimension199: cd199,
      ...(productName && { name: productName }),
      ...(sku && { skuId: sku }),
    };
  }
  return mpackTags;
};

const getMpackPageType = (multiPackProductType, originPage) => {
  const gaAnalyticsConfKey = 'GA_ANAYTICS';
  let mpackPageType = '';
  if (multiPackProductType) {
    switch (originPage) {
      case 'pdp':
        mpackPageType =
          multiPackProductType === MULTI_PACK_TYPE.MULTIPACK
            ? ADDEDTOBAG_CONSTANTS[gaAnalyticsConfKey].PDP_MULTIPACK
            : ADDEDTOBAG_CONSTANTS[gaAnalyticsConfKey].PDP_SINGLE;
        break;
      case 'spdp':
        mpackPageType = ADDEDTOBAG_CONSTANTS[gaAnalyticsConfKey].SEARCH_PDP_MPACK;
        break;
      case 'slp':
        mpackPageType = ADDEDTOBAG_CONSTANTS[gaAnalyticsConfKey].SLP_MPACK;
        break;
      case 'plp':
        mpackPageType = ADDEDTOBAG_CONSTANTS[gaAnalyticsConfKey].PLP_MPACK;
        break;
      default:
        break;
    }
  }
  return mpackPageType;
};

export function* getDimension2Value(product) {
  const { dimension92 } = product || {};

  const path = isClient() ? window.location.href : null;
  if (path) {
    if (path.includes('/outfit/')) return 'outfit';
    if (path.includes('content')) return 'content page';
    if (path.includes('/b/')) return 'bundle';
  }
  if (dimension92) return Constants.RECOMMENDATIONS_PAGES_MAPPING.RECOMMENDATIONS;

  const pageData = yield select(getPageData);
  return (pageData && pageData.pageType) || 'browse';
}

const getFormattedProducts = (
  products,
  multiPackProductType,
  originPage,
  selectedMultipack,
  userId = '',
  isHideOriginalPriceAndMarchantTagEnabled
) => {
  if (!products) return null;
  const { isOutfitPage } = products;
  const outfitArr = isOutfitPage ? { metric77: '1' } : {};
  const {
    dimension20: cd20,
    dimension21: cd21,
    dimension92: cd92,
    dimension2: cd2,
    fromAtc,
  } = products;
  const customDimension2 = products?.cd2;
  const mpackTags = getMpackTgas(multiPackProductType, originPage, selectedMultipack);
  const cd66 = products?.dimension66;
  const cd158 = products?.cd158;
  const cd81 = products?.dimension81;
  const pdpThroughStye = window?.location?.href.includes('syte_ref=discovery_button');
  if (pdpThroughStye) {
    const getSyteProducts = getSessionStorage('syteProductsInBag');
    setSessionStorage({
      key: 'syteProductsInBag',
      value: getSyteProducts
        ? getSyteProducts?.toString().concat(`,${products?.colorId}`)
        : `${products?.colorId}`,
    });
    setSessionStorage({
      key: 'syteUserId',
      value: userId,
    });
  }

  const originalPrice = getOriginalPrice({
    hardMarkDown: products?.hardMarkDown,
    isHideOriginalPriceAndMarchantTagEnabled,
    listPrice: products.listPrice,
    currency: products.CurrCurrency,
    fromAddedToCart: true,
    prodPartNo: products?.currentProductId || products?.partNumber || products?.colorId,
  });

  return {
    id: products?.partNumber || products?.colorId,
    price: products.price,
    brand: products.brand,
    variant: products.prodColor,
    category: products.category,
    quantity: products.quantity,
    metric61: products.cartPrice,
    metric85: products.price,
    dimension2: fromAtc ? customDimension2 : cd2 || getDimension2Value(products) || 'browse',
    dimension20: cd20 || '',
    dimension21: cd21 || '',
    dimension92: cd92 || '',
    dimension35: products.brand,
    dimension63: `${products.price}${products.CurrCurrency} ${originalPrice}`,
    dimension67: products.pricingState,
    dimension71: products.rating,
    dimension72: products.productFeatures,
    dimension77: products.prodColor,
    dimension80: products.category,
    dimension83: products.prodGender || products.gender,
    dimension88: products.size,
    dimension89: products?.partNumber || products?.colorId,
    dimension95: products?.sku,
    dimension66: cd66,
    dimension81: cd81,
    dimension158: cd158 || '',
    dimension108: products.cd108 || '',
    dimension109: products.cd109 || '',
    dimension122: products.cd122 || '',
    dimension130: products.cd130 || '',
    dimension135: products.cd135 || '',
    dimension139: products.cd139 || '',
    dimension101: products.quantity && pdpThroughStye ? 'shop similar' : '',
    ...mpackTags,
    ...outfitArr,
  };
};

const fireAnalyticsCall = (prodArr, product) => {
  if (fireEnhancedEcomm) {
    fireEnhancedEcomm({
      eventName: 'Add To Cart',
      productsObj: [prodArr],
      eventType: 'add',
      eventLabel: 'Add to cart',
      pageName: product.fromPageName,
      currCode: product.CurrCurrency,
      ...getCM2Event(),
    });
  }
};

const formatPromotionMessage = (promotionsData, TCPPromotionID) => {
  try {
    return promotionsData && promotionsData[TCPPromotionID]
      ? promotionsData[TCPPromotionID].description || ''
      : '';
  } catch (ex) {
    return '';
  }
};

export function* logAddToBagEvent({
  quantity,
  cartPrice,
  multiPackProductType,
  originPage,
  selectedMultipack = 1,
  categoryId,
  searchTerm,
  TCPPromotionID,
  accessoryOptions,
  bundleTrackingText,
  dimension66 = null,
  dimension81 = null,
  cd158 = null,
  cd108 = null,
  cd109 = null,
  cd122 = null,
  cd130 = null,
  cd135 = null,
  cd139 = null,
  cd2 = null,
  tileData,
  fromAtc,
  hardMarkDown,
  currentProductId,
}) {
  const clickAnalyticsData = yield select(getClickAnalyticsData) || {};
  const {
    departmentList = '',
    categoryList = '',
    listingSubCategory = '',
  } = clickAnalyticsData || {};
  const breadcrumbs = [departmentList, categoryList, listingSubCategory];
  const product = (clickAnalyticsData?.products && clickAnalyticsData.products[0]) || tileData;
  if (product) {
    product.dimension2 = yield call(getDimension2Value, product);
  }

  if (product) {
    product.quantity = parseInt(quantity, 10);
    product.cartPrice = parseFloat(cartPrice);
    product.mpackPageType = getMpackPageType(multiPackProductType, originPage);
    product.mpackValue = `${selectedMultipack}${ADDEDTOBAG_CONSTANTS.GA_ANAYTICS.PACK}`;
    if (isClient()) {
      if (categoryId) {
        product.categoryId = categoryId;
      }
      if (searchTerm) {
        product.searchTerm = searchTerm;
      }
    }
    if (dimension66) {
      product.dimension66 = dimension66;
    }
    if (dimension81) {
      product.dimension81 = dimension81;
    }
    if (cd158) {
      product.cd158 = cd158;
    }
    if (cd108) {
      product.cd108 = cd108;
    }
    if (cd109) {
      product.cd109 = cd109;
    }
    if (cd122) {
      product.cd122 = cd122;
    }
    if (cd130) {
      product.cd130 = cd130;
    }
    if (cd135) {
      product.cd135 = cd135;
    }
    if (cd139) {
      product.cd139 = cd139;
    }
    if (cd2) {
      product.cd2 = cd2;
    }
    if (fromAtc) {
      product.fromAtc = fromAtc;
    }
    if (hardMarkDown) {
      product.hardMarkDown = hardMarkDown;
    }
    if (currentProductId) {
      product.currentProductId = currentProductId;
    }
  }
  const updatedClickAnalyticsData = { ...clickAnalyticsData };
  const breadcrumbString = breadcrumbs.reduce((bdString, current) => {
    return current ? `${bdString}${bdString ? ':' : ''}${current}` : bdString;
  }, '');
  const userId = yield select(getUserId);
  const isHideOriginalPriceAndMarchantTagEnabled = yield select(
    getIsHideOriginalPriceAndMarchantTagEnabled
  );

  const prodArr = getFormattedProducts(
    product,
    multiPackProductType,
    originPage,
    selectedMultipack,
    userId,
    isHideOriginalPriceAndMarchantTagEnabled
  );
  if (prodArr) {
    if (isClient() && (product?.searchTerm || product?.categoryId)) {
      if (product?.searchTerm) {
        prodArr.dimension75 = product.searchTerm;
      } else {
        prodArr.dimension76 = product.categoryId;
      }
    }

    if (isClient() && TCPPromotionID) {
      const promotionsData = yield select(getPromotionsData);
      prodArr.dimension56 = formatPromotionMessage(promotionsData, TCPPromotionID);
    }

    if (isClient() && accessoryOptions && accessoryOptions.length) {
      prodArr.dimension11 = accessoryOptions;
      updatedClickAnalyticsData.backpack_metrics32 = 1;
    }
  }
  if (isClient() && bundleTrackingText && bundleTrackingText.length) {
    updatedClickAnalyticsData.promotion_cd58 = bundleTrackingText;
    updatedClickAnalyticsData.promotion_metrics17 = 1;
  }
  setProp('prop23', breadcrumbString);
  yield put(
    trackClickWithData(updatedClickAnalyticsData, {
      name: 'add_to_cart',
      module: 'browse',
    })
  );
  if (product) {
    fireAnalyticsCall(prodArr, product);
  }
}

export function* logMultiAddToBagEvent({ cartPrice, originPage, products }) {
  const { selectedCategoryId } = products[0];
  const productsNew = products.map((product, i) => {
    const { productId, offerPrice, size, skuId, TCPStyleQTY, TCPStyleType, color } =
      product.skuInfo;
    const {
      productName,
      fromPage,
      outfitId,
      brand,
      ratings,
      reviewsCount,
      addedFromSBP,
      quantity,
      listPrice,
      title,
      priceCurrency,
    } = product;
    return {
      isOutfitPage: title === 'COMPLETE THE LOOK',
      fromPageName: fromPage,
      CurrCurrency: priceCurrency,
      color: [color.name],
      colorId: productId,
      extPrice: listPrice,
      id: productId,
      listPrice,
      name: productName,
      outfitId,
      paidPrice: offerPrice,
      plpClick: false,
      position: i + 1,
      price: offerPrice,
      prodBrand: brand,
      rating: ratings,
      recsPageType: fromPage,
      recsProductId: productId,
      recsType: `${title === 'COMPLETE THE LOOK' ? 'CTL' : title}`,
      reviews: reviewsCount,
      searchClick: false,
      size,
      sku: skuId,
      quantity: parseInt(quantity, 10),
      cartPrice: parseFloat(cartPrice),
      mpackPageType: getMpackPageType(TCPStyleType, originPage),
      mpackValue: `${TCPStyleQTY || 1}${ADDEDTOBAG_CONSTANTS.GA_ANAYTICS.PACK}`,
      sbp: addedFromSBP || false,
      pricingState: offerPrice < listPrice ? 'on sale' : 'full price',
    };
  });
  const eventsData = ['scAdd', 'event61'];
  const cartsSessionStatus = yield select(getCartsSessionStatus);
  if (cartsSessionStatus) {
    eventsData.push('scOpen');
    yield put(setCartsSessionStatus(0));
  }

  const clickAnalyticsData = {
    customEvents: eventsData,
    CartAddProductId: selectedCategoryId,
    linkName: 'cart add',
    pageName: 'outfit',
    pageSection: 'outfit',
    pageShortName: 'outfit',
    pageSubSection: 'outfit',
    pageType: 'outfit',
    products: productsNew,
  };

  const updatedClickAnalyticsData = { ...clickAnalyticsData };

  yield put(
    trackClickWithData(updatedClickAnalyticsData, {
      name: 'add_to_cart',
      module: 'browse',
    })
  );
}

export function* logAdobeAddToBagEvent({
  multiPackProductType,
  skuInfo,
  cd108 = '',
  cd109 = '',
  cd2 = '',
  tileData,
  fromAtc,
  cartType = '',
  prevCartCount,
}) {
  const clickAnalyticsData = yield select(getClickAnalyticsData);
  const product = (clickAnalyticsData?.products && clickAnalyticsData?.products[0]) || tileData;
  if (product) {
    product.addToBagMethod = yield call(getDimension2Value, product);
    product.addToBagMethod = fromAtc ? cd2 : product?.addToBagMethod || 'browse';
  }
  const updatedProduct = {
    SKU: product?.colorId || skuInfo?.productId,
    name: skuInfo?.name || product?.name,
    _id: product?.category || '',
    productID: (skuInfo?.variantId || '')?.concat('-', product?.colorId || '') || '',
    productBrand: product?.brand || skuInfo?.brand,
    productSiteBrand: getAPIConfig()?.brandId || '',
    productSize: skuInfo?.size || '',
    productColor: skuInfo?.color?.name,
    productUID: skuInfo?.variantId || '',
    productCurrentPrice: skuInfo?.offerPrice?.toString() || '',
    productOriginalPrice: skuInfo?.listPrice?.toString() || '',
    productPriceVariance: (skuInfo?.listPrice - skuInfo?.offerPrice)?.toString() || '',
    productAverageRating: product?.rating || '',
    productListPosition: '',
    productBadge: cd108 || cd109 || '',
    productPricingState:
      skuInfo?.offerPrice < skuInfo?.listPrice
        ? ADDEDTOBAG_CONSTANTS?.ADOBE_ANALYTICS?.PRICING_ON_SALE
        : ADDEDTOBAG_CONSTANTS?.ADOBE_ANALYTICS?.PRICING_FULL_PRICE || product?.pricingState,
    productMPack:
      product?.mpackValue ||
      `${skuInfo?.TCPStyleQTY || 1}${ADDEDTOBAG_CONSTANTS?.ADOBE_ANALYTICS?.PACK}`,
    productMPackStyleType: getMultiPackStyleType(multiPackProductType) || '',
    productGender: product?.prodGender || product?.gender || '',
    productAddToBagMethod: product?.addToBagMethod || '',
    quantityAddedToBag: skuInfo?.quantity || product?.quantity,
    bestSellerSearchTerm: product?.searchTerm || '',
    bestSellerCategoryID: product?.categoryId || '',
    productCrossSellDriver: product?.d92 || product?.dimension92 || '',
    cartType,
  };
  pushEventToAdobeAnalytics('add_to_cart', { data: [updatedProduct], prevCartCount });
}

export function* loopMultiProducts({ productArr, item, index }) {
  const addToBagMethod = yield call(getDimension2Value, productArr);
  return {
    SKU: item?.skuInfo?.productId || '',
    name: item?.productName || '',
    _id: '',
    productID: (item?.skuInfo?.variantId || '')?.concat('-', item?.skuInfo?.productId || '') || '',
    productBrand: item?.brand || '',
    productSiteBrand: getAPIConfig()?.brandId || '',
    productSize: item?.skuInfo?.size || '',
    productColor: item?.skuInfo?.color?.name || '',
    productUID: item?.skuInfo?.variantId || '',
    productCurrentPrice: item?.skuInfo?.offerPrice?.toString() || '',
    productOriginalPrice: item?.skuInfo?.listPrice?.toString() || '',
    productPriceVariance: (item?.skuInfo.listPrice - item?.skuInfo?.offerPrice)?.toString() || '',
    productAverageRating: '',
    productListPosition: index + 1,
    productBadge: '',
    productPricingState:
      item?.skuInfo?.pricingState || item?.skuInfo?.offerPrice < item?.skuInfo?.listPrice
        ? ADDEDTOBAG_CONSTANTS?.ADOBE_ANALYTICS?.PRICING_ON_SALE
        : ADDEDTOBAG_CONSTANTS?.ADOBE_ANALYTICS?.PRICING_FULL_PRICE || '',
    productMPack:
      `${item?.skuInfo?.TCPStyleQTY}${ADDEDTOBAG_CONSTANTS?.ADOBE_ANALYTICS?.PACK}` || '',
    productMPackStyleType: item?.skuInfo?.TCPStyleType
      ? getMultiPackStyleType(item?.skuInfo?.TCPStyleType)
      : '',
    productGender: item?.prodGender || item?.gender || '',
    productAddToBagMethod: addToBagMethod || 'browse',
    cartType: 'standard',
  };
}

export function* logAdobeMultiAddToBagEvent({ products }) {
  return yield all(
    products?.map((item, index) => call(loopMultiProducts, { products, item, index }))
  );
}

const getPrevCartCount = (prevCartCount) => {
  return parseInt(prevCartCount || 0, 10);
};

export function* makeNavigateXHrCall(obj) {
  const { prevCartCount } = obj || {};
  const isGuestUser = yield select(getIsGuest);
  if (isGuestUser && !prevCartCount) {
    yield put(navigateXHRAction());
  }
}

export function* isSuppressGetOrderDetails() {
  return yield select(getIsSuppressGetOrderDetails);
}

export function* isAvoidGetOrderDetails() {
  return yield select(getIsAvoidGetOrderDetails);
}

export function* isgetABTestAddToBagDrawer() {
  return yield select(getABTestAddToBagDrawer);
}
export function* isOptimisticAddBagModal() {
  return yield select(getOptimisticAddBagModal);
}

export function* isBundleTrackerEnabled() {
  return yield select(getIsBundleTrackerEnabled);
}

const getExternalID = (itemId, wishlistItemId) => {
  return itemId || wishlistItemId || '';
};

export const checkLoyaltyNAFlag = (res) => {
  return (
    res &&
    !res.isBrierleyWorking &&
    res.pointsApi &&
    res.pointsApi.toUpperCase() === ADDEDTOBAG_CONSTANTS.NA
  );
};

export const filterMultiPackVariant = (getAllMultiPack, skuInfo) => {
  return getAllMultiPack.filter((product) => {
    const { TCPMultiPackReferenceUSStore } = product;
    return skuInfo.color.name.toLowerCase() === product.name.toLowerCase()
      ? TCPMultiPackReferenceUSStore
      : null;
  });
};

const getCatEntryIdForMultiAdd = (productItemsInfo) => {
  return productItemsInfo.map((product) => {
    const { skuId: catEntryId } = product.skuInfo;
    return catEntryId;
  });
};

const getQuantityForMultiAdd = (productItemsInfo) => {
  return productItemsInfo.map((product) => {
    const { skuId: catEntryId } = product.skuInfo;
    return `${catEntryId}:${product.quantity.toString()}`;
  });
};

export const getParams = (payload, extendedOrderValue) => {
  const isMultipleAdd = payload.productItemsInfo && payload.productItemsInfo.length;
  const { accessories } = payload;
  const newPayload = isMultipleAdd ? payload.productItemsInfo[0] : payload;
  const {
    skuInfo,
    getAllMultiPack,
    getAllNewMultiPack,
    quantity,
    multipackProduct,
    multiPackItems,
    itemId,
    wishlistItemId,
    fromFavorites,
    partIdInfo,
    itemInfo = {},
    primaryBrand,
    brand,
    alternateBrand,
    bossDisabledFlags,
    hardMarkDown,
    productInfo,
    TCPPromotionID,
  } = newPayload;
  const isMultiPackVariant = !!getAllMultiPack && filterMultiPackVariant(getAllMultiPack, skuInfo);
  const { storeId, langId, catalogId } = getAPIConfig();
  const multipackCatentryId = multiPackItems || null;
  const multipackIds = multipackProduct || null;
  const apiConfigParams = {
    catalogId,
    storeId,
    langId,
  };
  const getCatId = !multipackIds
    ? null
    : filterItems(getAllNewMultiPack, getAllMultiPack, skuInfo, partIdInfo);
  const {
    variantId,
    prodPartNo,
    size,
    fit,
    TCPStyleType,
    TCPStyleQTY,
    TCPWebOnlyFlagStore,
    TCPProductIndStore,
    imageUrl,
    color,
    variantNo,
    LoyaltyPromoMultiplierStore,
    LoyaltyPromoPLCCMultiplierStore,
    productId,
    preOrderDate,
    listPrice,
    seoToken: seoTokenSkuInfo,
  } = skuInfo || {};
  const { seoToken: seoTokenProductInfo } = productInfo || {};
  const isExtendedPreOrder = getIsExtendedPreorder(preOrderDate, extendedOrderValue);
  const categoryEntryId = isMultipleAdd
    ? getCatEntryIdForMultiAdd(payload.productItemsInfo)
    : skuInfo.skuId;
  const productQuantity =
    isMultipleAdd > 1 ? getQuantityForMultiAdd(payload.productItemsInfo) : quantity.toString();
  const seoToken = seoTokenProductInfo || seoTokenSkuInfo;
  return {
    ...apiConfigParams,
    orderId: '.',
    field2: '0',
    requesttype: 'ajax',
    catEntryId: categoryEntryId,
    quantity: productQuantity,
    'calculationUsage[]': '-7',
    externalId: getExternalID(itemId, wishlistItemId),
    multipackCatentryId:
      isMultiPackVariant &&
      isMultiPackVariant[0] &&
      isMultiPackVariant[0].TCPMultiPackUSStore &&
      getCatId
        ? getCatId
        : multipackCatentryId,
    productId: variantId || productId,
    productPartNo: prodPartNo,
    giftItem: payload.isGiftCard,
    size,
    fit,
    TCPStyleType,
    TCPStyleQTY,
    TCPWebOnlyFlagStore: parseBoolean(TCPWebOnlyFlagStore),
    TCPProductIndStore: TCPProductIndStore || '',
    productUrl: imageUrl,
    productColor: color.name,
    variantNo,
    LoyaltyPromoMultiplierStore,
    LoyaltyPromoPLCCMultiplierStore,
    fromFavorites,
    preOrderDate,
    accessories,
    brand: primaryBrand || alternateBrand || brand || itemInfo?.itemBrand || '',
    TCPPromotionID,
    listPrice,
    wasPrice: itemInfo?.wasPrice,
    bossDisabledFlags,
    isExtendedPreOrder,
    seoToken,
    isHardMarkEnabled: parseBoolean(hardMarkDown),
  };
};

function* updateBagActions(res, fromStyleWith) {
  const loyaltyPayload = {
    isBrierleyWorking: res && res.isBrierleyWorking,
    estimatedRewards: res && res.estimatedRewards,
    pointsToNextReward: res && res.pointsToNextReward,
    earnedReward: res && res.earnedReward,
  };
  yield put(updateCartCount(res));
  yield put(setOrderId(res));
  yield put(updateCartPriceData(res));
  yield put(updateOrderTypeData(res));
  yield put(updateLoyaltyPoints(loyaltyPayload));
  if (fromStyleWith) {
    yield put(setGhostLoaderStateComplete({ addedToBagLoaderCompleteState: true }));
  }
}

export function* addToCartUpdateLocalData(orderType, payload, apiResp) {
  const { productName, quantity, skuInfo, isGiftCard, storeLocId } =
    orderType === ADDEDTOBAG_CONSTANTS.ADD_TO_CART_BOPIS ? payload.productInfo : payload;
  const { loyaltyOrderItems } = apiResp;
  const NULL_CONSTANT = 'null - null';
  const respItemObj =
    loyaltyOrderItems && loyaltyOrderItems.find((item) => item.c_variant === skuInfo.variantNo);

  /*  This object contains just enough basic data stored locally to support quicker rendering of
      the bag page and items. Not all fields will be available so some fields are hardcoded.
      It is not a replacement for the cart api call (which will return later). Once api call is
      complete, contents in the bag will be updated  and a re-render will occur.
  */
  if (respItemObj) {
    const cartAddItemData = {
      productInfo: {
        imagePath: skuInfo.imageUrl,
        size: skuInfo.size,
        generalProductId: skuInfo.productId,
        color: skuInfo.color,
        variantNo: skuInfo.variantNo,
        tcpStyleQty: skuInfo.TCPStyleQTY,
        upc: skuInfo.variantId,
        orderType: respItemObj.orderItemType,
        tcpStyleType: skuInfo.TCPStyleType,
        isGiftCard,
        name: productName,
        productPartNumber: skuInfo.productId,
        multiPackItems: null,
        itemPartNumber: skuInfo.variantId,
        fit: skuInfo.fit,
        multiPack: respItemObj.c_multiPack,
        pdpUrl: '', // unavailable
        itemBrand: respItemObj.c_brand,
        colorFitSizeDisplayNames: skuInfo.color,
        skuId: skuInfo.skuId,
      },
      badge: null,
      isOnlineOnly: false,
      isInventoryAvailBOSS: apiResp.isBossOrder,
      storeTomorrowOpenRange: NULL_CONSTANT,
      isBossEligible: apiResp.isBossOrder,
      clearanceItem: false,
      storeItemsCount: quantity,
      storeTodayOpenRange: NULL_CONSTANT,
      itemPlccPointsMultiplier: '1',
      storeAddress: {
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zipCode: '',
      },
      miscInfo: {
        itemMprPointsMultiplier: '1',
        store: '',
        vendorColorDisplayId: skuInfo.productId,
        bossStartDate: {
          day: '',
          month: '',
          date: '',
          year: '',
        },
        badge: null,
        isOnlineOnly: false,
        isInventoryAvailBOSS: false,
        storeTomorrowOpenRange: NULL_CONSTANT,
        isBossEligible: apiResp.isBossOrder,
        clearanceItem: false,
        storeItemsCount: quantity,
        storeTodayOpenRange: NULL_CONSTANT,
        itemPlccPointsMultiplier: '1',
        storeAddress: {
          addressLine1: '',
          addressLine2: '',
          city: '',
          state: '',
          zipCode: '',
        },
        storePhoneNumber: '',
        isBopisEligible: apiResp.isBopisOrder,
        availability: 'OK',
        orderItemType: respItemObj.orderItemType,
        isStoreBOSSEligible: respItemObj.orderItemType === 'BOSS',
        storeId: orderType === ADDEDTOBAG_CONSTANTS.ADD_TO_CART_BOPIS ? storeLocId : '',
        bossEndDate: {
          day: '',
          month: '',
          date: '',
          year: '',
        },
      },
    };

    // Check existing store for cartOrderItemsLocal, add new entry
    const cartItemsArray = yield select(BagPageSelectors.getOrderItemsLocal);
    const newCartItemsArray = Array.from(cartItemsArray);
    newCartItemsArray.splice(0, 0, cartAddItemData);
    // Add new cart object
    yield put(setAddedToBagDataLocal(newCartItemsArray));
  }
}

/**
 * Apply coupons to the basket.
 * @param {Array} couponsToApply
 * @param {Array} couponMap
 * @param {boolean} fromUpdateItem
 * @returns {void} update couponMap based on the response.
 */
export function* applyCoupons(couponsToApply, couponMap, fromUpdateItem) {
  while (couponsToApply.length > 0) {
    const couponToApply = couponsToApply.pop();
    const didApplyCoupon = checkIfCouponApplied(couponToApply, couponMap);

    if (didApplyCoupon) {
      yield call(applyCoupon, {
        payload: { formData: { couponCode: couponToApply } },
        isCheckoutFlow: fromUpdateItem,
        fromCartPage: fromUpdateItem,
        coupon: couponToApply,
      });
    }
  }
}

/**
 * Remove coupons from the basket.
 * @param {Array} couponsToRemove
 * @param {Array} couponMap
 * @param {boolean} fromUpdateItem
 * @returns {void} update couponMap based on the response.
 */
export function* removeCoupons(couponsToRemove, couponMap, fromUpdateItem) {
  // looping through the coupons to remove.
  while (couponsToRemove.length > 0) {
    const couponToRemove = couponsToRemove.pop();
    const didRemoveCoupon = checkIfCouponRemoved(couponToRemove, couponMap);
    /* checking if there is need to make the remove coupon API call, because if the coupon
     is not applied or already removed then no need to call the API */
    /**
     * remove coupon saga will be triggered here, which will handle the process of removing coupon
     * from cart page.
     */
    if (didRemoveCoupon) {
      yield call(removeCoupon, {
        payload: {
          coupon: { id: couponToRemove },
          isCheckoutFlow: fromUpdateItem,
          fromCartPage: fromUpdateItem,
        },
      });
    }
  }
}

/**
 * Checks for coupons to apply and remove.
 * Applies or removes coupons based on the state retrieved from the store.
 * Logs any errors that occur during execution.
 * @param {boolean} fromUpdateItem - we are passing this flag to handle the edit modal/cart scenarios.
 * @returns {void}
 */
export function* checkForApplyAndRemoveCoupons(fromUpdateItem = false) {
  const methodName = 'checkForApplyAndRemoveCoupons';
  try {
    // couponsToApply/couponsToRemove - are the coupons we are getting from the PDP checkbox.
    const couponsToApply = yield select(getAppliedCouponsOnPDP);
    const couponsToRemove = yield select(getRemovedPromotionsOnPdp);
    // memoisedAppliedCoupon - the coupons which are already applied to the cart.
    /* we are using memoisedAppliedCoupon to make sure that we are not applying the already applied/removed coupons */
    const memoisedAppliedCoupons = yield select(getMemoisedCouponMap);
    let appliedCoupons = [];
    if (Array.isArray(memoisedAppliedCoupons)) {
      appliedCoupons = memoisedAppliedCoupons;
    } else if (memoisedAppliedCoupons) {
      appliedCoupons = [JSON.parse(memoisedAppliedCoupons)];
    }
    /* dispatching resetAppliedPromotions/resetRemovedPromotions actions to clear the state after all the coupons are processed,
    so that, when we add/remove coupon next time it will not entertain the already applied/removed coupons */
    // Apply Coupons
    if (Array.isArray(couponsToApply) && couponsToApply.length) {
      yield applyCoupons(couponsToApply, appliedCoupons, fromUpdateItem);
      yield put(resetAppliedPromotions(couponsToApply));
    }

    // Remove Coupons
    if (Array.isArray(couponsToRemove) && couponsToRemove.length) {
      yield removeCoupons(couponsToRemove, appliedCoupons, fromUpdateItem);
      yield put(resetRemovedPromotions(couponsToRemove));
    }
  } catch (error) {
    handleError({ error, payload: {}, methodName, fileName });
  } finally {
    /** triggering these actions to give and update to the UI */
    yield put(setUpdateCheckbox(true));
    yield put(setOfferPriceLoadingState(false));
  }
}

export function* addToCartEcom({ payload }) {
  let res;
  const {
    skipAddToBagModal,
    skuInfo,
    fromCompleteTheLook,
    fromStyleWith,
    originPage,
    productName,
    addedFromSBP,
    fromPage,
    fromFbt,
    categoryId = '',
    sflItems,
    tileData,
    isFromPjPlanner,
  } = payload;
  const isSupressAtbOnBag = fromPage === 'cart' ? yield select(getIsSupressATBModalOnBag) : false;
  try {
    if (isSupressAtbOnBag) {
      yield put(setAddedToBagBtnLoader(true));
    }
    yield put(setUnavailableProductIds(null));
    yield InjectLoyaltyDynamicStore();
    if (!fromStyleWith) {
      yield put(
        fetchAbTestData({
          payload: {
            abTest: {},
            pathname: window?.location?.pathname,
            page: 'added_to_bag',
            setAbtestScript: () => {},
          },
        })
      );
    }
    const sku = skuInfo.skuId;
    const multiPackProductType = skuInfo.TCPStyleType;
    const multiPackQty = skuInfo.TCPStyleQTY;
    const { isPdpPage, fromOutfitCarouselDetails } = payload;
    const isApplyCheckboxPromoOnPdp = yield select(getIsApplyCheckboxPromoOnPDPEnabled);
    const getaddToBagABTestDrawer = yield call(isgetABTestAddToBagDrawer);
    const getOptmisticBagModal = yield call(isOptimisticAddBagModal);
    const isOptmisticBagModal = !!getOptmisticBagModal && !isSupressAtbOnBag;
    const prevCartCount = yield call(getCartItemCount, true);
    const { callBack, fromMoveToBag } = payload;
    yield put(updateAddToBagInProgress(true));
    yield put(setGhostLoaderStateComplete({ addedToBagLoaderCompleteState: false }));
    yield put(setFbtComplete(false));
    yield put(setOfferPriceLoadingState(true));
    if (fromStyleWith) {
      yield put(setGhostLoaderState({ addedToBagLoaderState: true }));
    } else if (
      isOptmisticBagModal &&
      ((!fromMoveToBag && !isPdpPage) ||
        (!getaddToBagABTestDrawer && isPdpPage) ||
        (isPdpPage && isCanada()) ||
        !!fromCompleteTheLook)
    ) {
      yield put(setLoaderState(false));
      if (!isFromPjPlanner) yield put(openAddedToBag());
      const dimension66 = payload?.dimension66;
      const dimension81 = payload?.dimension81;
      const cd158 = payload?.cd158;
      yield put(
        SetAddedToBagData({
          ...payload,
          ...dimension66,
          ...dimension81,
          ...cd158,
          addedFromSBP,
        })
      );
    } else {
      yield put(setLoaderState(false));
    }
    const extendedOrderValue = yield select(getExtendedPreOrderValue);
    const params = getParams(payload, extendedOrderValue);
    params.skipLoyaltyCall = (isPdpPage && !!getaddToBagABTestDrawer) || !!skipAddToBagModal;
    yield put(clearAddToBagErrorState());
    yield put(setUnavailableProductIds(null));
    yield put(clearAddToCartFbtError());
    yield put(clearAddToCartMultipleItemErrorState());
    const errorMapping = yield select(BagPageSelectors.getErrorMapping);
    // const res = yield call(addCartEcomItem, params, errorMapping);
    let customType = '';
    const selectedAccessories = yield select(getSelectedAccessories);
    const selectedSecondaryAccessories = yield select(getSecondarySelectedAccessories);
    const orderItems = yield select(getCartOrderList);
    const bundleDataItems = yield select(getBundleData);
    const accessoriesDataPDP = yield select(getAccessoriesData);
    customType = accessoriesDataPDP && accessoriesDataPDP?.customizationType;
    let accessoriesDataQV;
    if (!accessoriesDataPDP?.customizationType) {
      accessoriesDataQV = yield select(getProductInfo);
      if (accessoriesDataQV) {
        const { product } = accessoriesDataQV[0] || {};
        const { accessoriesData } = product || {};
        const { customizationType } = accessoriesData;
        customType = customizationType;
      }
    }
    const isBundleTracker = yield call(isBundleTrackerEnabled);
    if (payload?.outfitCustomType) {
      customType = payload?.outfitCustomType;
    }

    // TODO: Call to getLoyaltyOrderItemPoints will have scope of modification when real API is ready.
    const loyaltyPointsRes = yield call(
      getLoyaltyOrderItemPoints,
      payload,
      errorMapping,
    );

    yield put(setLoyaltyOrderItemPoints(loyaltyPointsRes));

    res = yield call(
      addItemToCart,
      params,
      errorMapping,
      selectedAccessories,
      customType,
      selectedSecondaryAccessories,
      { sflItems, originPage, payload, orderItems, bundleDataItems, isBundleTracker }
    );
    yield put(callItemInBag());
    const respToProcess = res.addToBasketResp;
    const bundleData = (res && res?.bundleData) || [];
    yield put(setBundleData(bundleData));
    const dimension66 = payload?.dimension66;
    const dimension81 = payload?.dimension81;
    const cd158 = payload?.cd158;
    const cd108 = payload?.cd108;
    const cd109 = payload?.cd109;
    const cd122 = payload?.cd122;
    const cd135 = payload?.cd135;
    const cd139 = payload?.cd139;
    const cd2 = payload?.cd2;
    const fromAtc = payload?.fromAtc;
    delete res.addToBasketResp;
    yield put(
      SetAddedToBagData({
        ...payload,
        ...dimension66,
        ...dimension81,
        ...cd158,
        ...res,
        addedFromSBP,
      })
    );
    if (isFromPjPlanner) {
      yield put(openAddedToBag());
    }
    yield updateBagActions(res, fromStyleWith);
    yield put(setCartUpdateComplete(true));
    if (callBack) {
      callBack();
    }
    yield put(BAG_PAGE_ACTIONS.setBagLoadedState());
    const hasLoyaltyABTestEnabled = isPdpPage && !isCanada() && checkLoyaltyNAFlag(res);
    yield put(setLoyaltyABTestFlag(false));
    yield put(setLoaderState(false));

    if (skipAddToBagModal || hasLoyaltyABTestEnabled) {
      yield put(resetBagLoadingState());
      yield put(setAddedToBagButton(skuInfo.unbxdProdId));
    } else if (
      (!fromMoveToBag && !isPdpPage) ||
      (!getaddToBagABTestDrawer && isPdpPage) ||
      (isPdpPage && isCanada()) ||
      !!fromCompleteTheLook
    ) {
      if (!isOptmisticBagModal && !isSupressAtbOnBag) {
        yield put(openAddedToBag());
      }
      if (fromPage !== Constants.RECOMMENDATIONS_PAGES_MAPPING.BAG) {
        yield put(resetBagLoadingState());
        // set the flag that is being set from getOrderDetails unconditionally
        yield put(toggleCheckoutRouting(true));
      }
    }
    if (fromOutfitCarouselDetails) {
      yield put(setOutfitCarouselAddedButton(true));
    }
    if (
      (getaddToBagABTestDrawer && isPdpPage && !isCanada()) ||
      (skipAddToBagModal && !fromOutfitCarouselDetails) ||
      hasLoyaltyABTestEnabled
    ) {
      yield put(addedTobagMsg(true));
      yield put(setLoyaltyABTestFlag(true));
    } else {
      yield put(addedTobagMsg(false));
    }

    if (isSupressAtbOnBag) {
      yield put(setAddedToBagBtnLoader(false));
    }
    // Calculate Loyalty Points

    if (
      res &&
      fromPage !== Constants.RECOMMENDATIONS_PAGES_MAPPING.BAG &&
      !params.skipLoyaltyCall
    ) {
      yield put(
        simulateLoyaltyDetail({
          ...payload,
          ...res,
          source: 'AddedToBag',
        })
      );
    }

    const isCartCacheExist = yield call(getCache, 'getCart');
    if (!isCartCacheExist) {
      yield put(
        BAG_PAGE_ACTIONS.getCachedCartData({
          itemsInCart: respToProcess?.productItems?.length || 0,
          addToBagResponse: respToProcess,
        })
      );
    } else {
      yield call(processMutationCachedDataSaga, {
        payload: {
          respToProcess,
          skipCache: fromPage === Constants.RECOMMENDATIONS_PAGES_MAPPING.BAG,
        },
      });
    }

    yield call(makeNavigateXHrCall, { prevCartCount: getPrevCartCount(prevCartCount) });
    const ghostLoaderCompleteState = yield select(getAddedToBagGhostLoaderCompleteState);
    let mPackData = yield select(getBagAnalyticsData);
    if (!mPackData) {
      mPackData = [];
    }
    const mpackTags = getMpackTgas(
      multiPackProductType,
      originPage,
      multiPackQty,
      productName,
      sku
    );
    mPackData.push(mpackTags);
    yield put(setBagAnalytics(mPackData));
    const { accessories } = params;
    let accessoryOptions;
    if (accessories && accessories.length) {
      accessoryOptions = `${customType}|${accessories.length}`;
    }
    const { variantId } = skuInfo;
    let bundleTrackingText;
    if (bundleData && bundleData.length && variantId) {
      const addedBundleProduct = bundleData.filter((item) => {
        const promotion = item?.TCPPromotions?.split(':');
        return promotion && promotion[1] && item?.productId === variantId;
      });
      const orderItemsCopy = orderItems || [];
      const orderedItems = JSON.parse(JSON.stringify(orderItemsCopy));
      const productInCart =
        orderedItems.filter((item) => item?.productInfo?.generalProductId === variantId)[0] || [];
      if (addedBundleProduct && addedBundleProduct.length) {
        const bundleProduct = addedBundleProduct[0];
        const promotion = bundleProduct?.TCPPromotions?.split(':') || [];
        const requiredQuantity = Number(promotion[1]) || 1;
        const addedQuantity = bundleProduct.quantity;
        const totalQuantityInCart = (productInCart?.itemInfo?.quantity || 0) + addedQuantity;
        let currentIndex = 1;
        if (totalQuantityInCart <= requiredQuantity) {
          currentIndex = totalQuantityInCart;
        } else if (totalQuantityInCart > requiredQuantity) {
          currentIndex = totalQuantityInCart - requiredQuantity;
        }
        const isLast = currentIndex === requiredQuantity;
        bundleTrackingText = `product${currentIndex === 1 ? '1|start' : `${currentIndex}`}${
          isLast ? '|complete' : ''
        }`;
      }
    }
    const cd66 = dimension66;
    const cd81 = dimension81;
    yield put(setCD66({ cd66, variantId }));
    yield put(setCD81({ cd81, variantId }));
    yield call(logAddToBagEvent, {
      quantity: payload.quantity,
      cartPrice: res?.orderTotal,
      multiPackProductType,
      originPage,
      selectedMultipack: multiPackQty,
      addedFromSBP,
      dimension66,
      dimension81,
      cd158,
      cd108,
      cd109,
      cd122,
      cd135,
      cd139,
      cd2,
      categoryId,
      searchTerm: payload?.searchTerm || '',
      TCPPromotionID: payload.TCPPromotionID || '',
      accessoryOptions,
      bundleTrackingText,
      tileData,
      fromAtc,
      hardMarkDown: payload?.hardMarkDown || '',
      currentProductId: payload?.skuInfo?.prodPartNo,
    });
    if (multiPackProductType === MULTI_PACK_TYPE.MULTIPACK) {
      if (multiPackProductType !== null)
        yield put(setMultipackProductType(MULTI_PACK_TYPE.MULTIPACK));
      yield put(setIsMultipackItem(true));
    } else {
      yield put(setMultipackProductType(multiPackProductType));
      yield put(setIsMultipackItem(false));
    }
    yield put(updateMiniBagFlag(true));
    yield fork(logAdobeAddToBagEvent, {
      multiPackProductType,
      skuInfo: {
        ...skuInfo,
        brand: payload?.brand || payload?.primaryBrand,
        name: payload?.productName,
        quantity: payload?.quantity,
      },
      cd108,
      cd109,
      cd2,
      tileData,
      fromAtc,
      cartType: 'standard',
      prevCartCount,
    });
    if (fromStyleWith && ghostLoaderCompleteState) {
      yield delay(ADDEDTOBAG_CONSTANTS.GHOST_LOADER_DELAY);
      yield put(setFbtComplete(true));
      yield put(setGhostLoaderState({ addedToBagLoaderState: false }));
      yield put(setGhostLoaderStateComplete({ addedToBagLoaderCompleteState: false }));
    }
    yield put(updateAddToBagInProgress(false));
    const isCouponOnHoldNewDesignEnabled = yield select(getcouponOnHoldNewDesign);
    if (respToProcess && respToProcess.c_couponMap) {
      yield put(
        updateOnHoldCoupons({
          appliedCoupons: respToProcess.c_couponMap,
          isCouponOnHoldNewDesignEnabled,
        })
      );
    }
    if (respToProcess && respToProcess.c_couponMap) {
      yield put(updateExpiredCoupons({ appliedCoupons: respToProcess.c_couponMap }));
    }
    if (isApplyCheckboxPromoOnPdp) {
      yield checkForApplyAndRemoveCoupons();
    } else {
      yield put(setOfferPriceLoadingState(false));
    }
  } catch (err) {
    yield put(setUpdateCheckbox(true));
    yield put(setOfferPriceLoadingState(false));
    const errorMapping = yield select(BagPageSelectors.getErrorMapping);
    const pageData = yield select(getPageData);
    const pageType = pageData && pageData.pageType;
    const errMsg = getErrorMessage(err, errorMapping, pageType);

    if (fromFbt) {
      yield put(setAddToCartFbtError(errMsg, payload.skuInfo.unbxdProdId));
    } else {
      yield put(AddToCartError(errMsg, payload.skuInfo.unbxdProdId));
    }
    if (isFromPjPlanner) {
      yield put(openAddedToBag());
    }
    yield put(setGhostLoaderState({ addedToBagLoaderState: false }));
    yield put(setGhostLoaderStateComplete({ addedToBagLoaderCompleteState: false }));
    yield put(setLoaderState(false));
    yield put(updateAddToBagInProgress(false));
    if (isSupressAtbOnBag) {
      yield put(setAddedToBagBtnLoader(false));
    }
  }
  if (res?.errorResponse && res?.errorMessage) {
    return res;
  }
  return null;
}

export function* suppressGetOrderDetailsCheck() {
  return !(yield call(isAvoidGetOrderDetails));
}

export function* addItemToCartBopis({ payload }) {
  try {
    const {
      productInfo,
      productInfo: {
        storeLocId,
        isBoss,
        quantity,
        TCPPromotionID,
        skuInfo: {
          skuId,
          variantId,
          variantNo,
          prodPartNo,
          imageUrl,
          size,
          fit,
          color,
          LoyaltyPromoMultiplierStore,
          LoyaltyPromoPLCCMultiplierStore,
          productId,
          preOrderDate,
          listPrice,
          TCPStyleType,
          TCPStyleQTY,
          TCPWebOnlyFlagStore,
          TCPProductIndStore,
          seoToken,
        },
        primaryBrand,
        brand,
        itemInfo,
        hardMarkDown,
      },
      callback,
      categoryId,
      bossDisabledFlags,
      cd130,
      fromAtc,
      fromPage,
    } = payload;
    const PICKUP_TYPE = {
      boss: 'boss',
      bopis: 'bopis',
    };
    const params = {
      storeLocId: storeLocId.toString(),
      quantity,
      catEntryId: skuId,
      isRest: 'false',
      pickupType: isBoss ? PICKUP_TYPE.boss : PICKUP_TYPE.bopis,
      variantNo,
      itemPartNumber: variantId,
      productUrl: imageUrl,
      giftItem: payload.isGiftCard,
      size,
      fit,
      productColor: color?.name,
      productPartNo: prodPartNo,
      LoyaltyPromoMultiplierStore,
      LoyaltyPromoPLCCMultiplierStore,
      productId: variantId || productId,
      preOrderDate,
      listPrice,
      TCPStyleType,
      TCPStyleQTY,
      TCPWebOnlyFlagStore,
      TCPProductIndStore,
      TCPPromotionID,
      brand: primaryBrand || brand || itemInfo?.itemBrand || '',
      bossDisabledFlags,
      seoToken,
      hardMarkDown,
    };
    yield put(setInventoryUnavailable(false));
    yield put(clearAddToCartMultipleItemErrorState());
    const isSupressAtbOnBag = fromPage === 'cart' ? yield select(getIsSupressATBModalOnBag) : false;
    if (isSupressAtbOnBag) {
      yield put(setAddedToBagBtnLoader(true));
    }
    const isApplyCheckboxPromoOnPdp = yield select(getIsApplyCheckboxPromoOnPDPEnabled);
    yield InjectLoyaltyDynamicStore();
    yield put(updateAddToBagInProgress(true));
    const getOptmisticBagModal = yield call(isOptimisticAddBagModal);
    const isOptmisticBagModal = !!getOptmisticBagModal && !isSupressAtbOnBag;
    const prevCartCount = yield call(getCartItemCount, true);
    yield put(clearAddToPickupErrorState());
    yield put(setOfferPriceLoadingState(true));
    const errorMapping = yield select(BagPageSelectors.getErrorMapping);
    if (isOptmisticBagModal) {
      yield put(clearAddToBagErrorState());
      yield put(setUnavailableProductIds(null));
      yield put(setLoaderState(false));
      yield put(openAddedToBag());
      yield put(
        SetAddedToBagData({
          ...payload,
          ...productInfo,
          pickupType: isBoss ? PICKUP_TYPE.boss : PICKUP_TYPE.bopis,
        })
      );
    }
    const selectedAccessories = yield select(getSelectedAccessories);
    const selectedSecondaryAccessories = yield select(getSecondarySelectedAccessories);
    let customType = '';
    const accessoriesDataPDP = yield select(getAccessoriesData);
    customType = accessoriesDataPDP && accessoriesDataPDP?.customizationType;
    let accessoriesDataQV;
    if (!accessoriesDataPDP?.customizationType) {
      accessoriesDataQV = yield select(getProductInfo);
      if (accessoriesDataQV) {
        const { product } = accessoriesDataQV[0] || {};
        const { accessoriesData } = product || {};
        const { customizationType } = accessoriesData;
        customType = customizationType;
      }
    }
    const isBundleTracker = yield call(isBundleTrackerEnabled);
    const orderItems = yield select(getCartOrderList);
    const bundleDataItems = yield select(getBundleData);
    const res = yield call(addCartBopisItem, params, errorMapping, {
      orderItems,
      bundleDataItems,
      isBundleTracker,
      selectedAccessories,
      customType,
      selectedSecondaryAccessories,
      payload,
    });
    const respToProcess = res.addToBasketResp;
    const bundleData = (res && res?.bundleData) || [];
    yield put(setBundleData(bundleData));
    yield put(callItemInBag());
    delete res.addToBasketResp;
    const loyaltyPayload = {
      isBrierleyWorking: res && res.isBrierleyWorking,
      estimatedRewards: res && res.estimatedRewards,
      pointsToNextReward: res && res.pointsToNextReward,
      earnedReward: res && res.earnedReward,
    };
    if (yield call(isAvoidGetOrderDetails)) {
      yield put(BAG_PAGE_ACTIONS.resetBagLoadingState());
      yield put(BAG_PAGE_ACTIONS.updateCartCount(res));
      yield put(BAG_PAGE_ACTIONS.setOrderId(res));
      yield put(BAG_PAGE_ACTIONS.updateCartPriceData(res));
      yield put(BAG_PAGE_ACTIONS.updateOrderTypeData(res));
      yield put(updateLoyaltyPoints(loyaltyPayload));
    }

    if (callback) {
      callback();
    }
    yield call(processMutationCachedDataSaga, {
      payload: {
        respToProcess,
        skipCache: false,
      },
    });

    yield call(processMutationNonCachedDataSaga, {
      payload: {
        respToProcess,
        isCheckoutFlow: true,
        ignoreCache: false,
      },
    });
    yield put(
      SetAddedToBagData({
        ...payload,
        ...productInfo,
        ...res,
        pickupType: isBoss ? PICKUP_TYPE.boss : PICKUP_TYPE.bopis,
      })
    );
    const isLoyaltyPointsEnabled = yield select(getIsPersistPointsApiEnabled);

    // Call Loyalty Points API when Brierley service is down And Get flag 'loyaltyCallEnabled' from cart Api
    if (
      (yield call(isAvoidGetOrderDetails)) &&
      isLoyaltyPointsEnabled &&
      fromPage !== Constants.RECOMMENDATIONS_PAGES_MAPPING.BAG
    ) {
      yield put(
        simulateLoyaltyDetail({
          ...payload,
          ...productInfo,
          ...res,
          source: 'AddedToBag',
          pickupType: isBoss ? PICKUP_TYPE.boss : PICKUP_TYPE.bopis,
        })
      );
    }
    if (!isOptmisticBagModal && !isSupressAtbOnBag) {
      yield put(openAddedToBag());
    }
    if (isSupressAtbOnBag) {
      yield put(closeQuickViewModal({ isModalOpen: false }));
      yield put(setAddedToBagBtnLoader(false));
    }
    yield put(setLoaderState(false));
    const isCartCacheExist = yield call(getCache, 'getCart');
    if (!isCartCacheExist) {
      yield put(BAG_PAGE_ACTIONS.getCachedCartData({}));
    }
    yield put(updateMiniBagFlag(true));
    yield fork(logAdobeAddToBagEvent, {
      multiPackProductType: productInfo?.skuInfo?.TCPStyleType,
      skuInfo: {
        ...productInfo?.skuInfo,
        brand: productInfo?.brand,
        name: productInfo?.productName,
        quantity: productInfo?.quantity,
      },
      fromAtc,
      cartType: isBoss ? PICKUP_TYPE?.boss : PICKUP_TYPE?.bopis,
    });
    yield call(makeNavigateXHrCall, { prevCartCount: getPrevCartCount(prevCartCount) });
    yield call(logAddToBagEvent, {
      quantity,
      cartPrice: res?.orderTotal,
      categoryId,
      searchTerm: payload.searchTerm || '',
      TCPPromotionID: TCPPromotionID || '',
      cd130,
      fromAtc,
    });
    yield addToCartUpdateLocalData(ADDEDTOBAG_CONSTANTS.ADD_TO_CART_BOPIS, payload, res);
    yield put(BAG_PAGE_ACTIONS.resetBagLoadingState());
    yield put(updateAddToBagInProgress(false));
    const isCouponOnHoldNewDesignEnabled = yield select(getcouponOnHoldNewDesign);
    if (respToProcess && respToProcess.c_couponMap) {
      yield put(
        updateOnHoldCoupons({
          appliedCoupons: respToProcess.c_couponMap,
          isCouponOnHoldNewDesignEnabled,
        })
      );
    }
    if (respToProcess && respToProcess.c_couponMap) {
      yield put(updateExpiredCoupons({ appliedCoupons: respToProcess.c_couponMap }));
    }
    if (isApplyCheckboxPromoOnPdp) {
      yield checkForApplyAndRemoveCoupons();
    } else {
      yield put(setOfferPriceLoadingState(false));
    }
  } catch (err) {
    yield put(clearAddToCartMultipleItemErrorState());

    yield put(updateAddToBagInProgress(false));
    yield put(setOfferPriceLoadingState(false));
    const errorMapping = yield select(BagPageSelectors.getErrorMapping);
    const errorMessage = getErrorMessage(err, errorMapping);
    const isNewErrorComponentEnabled = yield select(getNewGlobalErrorMessage);
    if (err?.errorMessageParam?.oosItem && isNewErrorComponentEnabled) {
      yield put(setInventoryUnavailable(true));
    }
    yield put(AddToPickupError(errorMessage));
    const isSupressAtbOnBag = yield select(getIsSupressATBModalOnBag);

    if (isSupressAtbOnBag && payload?.fromPage === 'cart') {
      yield put(setAddedToBagBtnLoader(false));
    }
    yield put(BAG_PAGE_ACTIONS.resetBagLoadingState());
  }
}

export function* openAddedToBagModal(
  products,
  prevCartCount,
  callBack,
  loyaltyPayload,
  isOutfitsOnBag,
  errMsg
) {
  const pageName = yield select(getPageName);
  if (isOutfitsOnBag) {
    yield put(setAddedToBagBtnLoader(false));
  } else yield put(setLoaderState(false));
  if (callBack && (!isOutfitsOnBag || (isOutfitsOnBag && !errMsg))) {
    callBack();
  }
  if (loyaltyPayload) {
    const { payload, lastProrduct, respToProcess } = loyaltyPayload;
    yield InjectLoyaltyDynamicStore();
    yield put(
      simulateLoyaltyDetail({
        ...payload,
        ...lastProrduct,
        source: 'AddedToBag',
      })
    );
    if (!isOutfitsOnBag) yield put(openAddedToBag());
    const isCartCacheExist = yield call(getCache, 'getCart');
    if (!isCartCacheExist) {
      yield put(
        BAG_PAGE_ACTIONS.getCachedCartData({
          itemsInCart: respToProcess?.productItems?.length || 0,
          addToBagResponse: respToProcess,
        })
      );
    } else {
      yield call(processMutationCachedDataSaga, {
        payload: {
          respToProcess,
        },
      });
    }
    yield put(resetBagLoadingState());
  } else {
    yield put(SetAddedToBagData([...products]));
    if (!isOutfitsOnBag) yield put(openAddedToBag());
    if (!(yield call(isSuppressGetOrderDetails)) || pageName === BAGPAGE_CONSTANTS.SHOPPING_BAG) {
      yield put(getOrderDetails({ recalcRewards: true }));
    } else yield put(resetBagLoadingState());
  }
  yield call(makeNavigateXHrCall, {
    prevCartCount: getPrevCartCount(prevCartCount),
  });
}

const getPayloadArray = (productItemsInfo, extendedOrderValue) => {
  return productItemsInfo.map((product) => {
    return {
      product,
      ...getParams(product, extendedOrderValue),
    };
  });
};

export function* addMultipleItemToCartECOM(payload, isOutfitsOnBag) {
  const { callBack, productItemsInfo, isFromPjPlanner } = payload;
  yield put(setUnavailableProductIds(null));
  yield put(
    fetchAbTestData({
      payload: {
        abTest: {},
        pathname: window?.location?.pathname,
        page: 'added_to_bag',
        setAbtestScript: () => {},
      },
    })
  );

  if (isOutfitsOnBag) {
    yield put(setAddedToBagBtnLoader(true));
  } else {
    yield put(setLoaderState(true));
  }
  const prevCartCount = yield call(getCartItemCount, true);
  const extendedOrderValue = yield select(getExtendedPreOrderValue);
  try {
    const paramsArray = getPayloadArray(productItemsInfo, extendedOrderValue);

    yield put(clearAddToBagErrorState());
    yield put(clearAddToCartFbtError());
    yield put(clearAddToCartMultipleItemErrorState());
    if (isOutfitsOnBag) {
      yield put(AddToCartOutfitItemError(null));
    }
    const errorMapping = yield select(BagPageSelectors.getErrorMapping);
    const res = yield call(addMultipleProductsInEcom, paramsArray, errorMapping);
    const lastProrduct = (res && res[res.length - 1]) || {};
    const { respToProcess } = lastProrduct;
    delete res[res.length - 1].respToProcess;

    const productAnalytics = yield call(logAdobeMultiAddToBagEvent, { products: res });
    pushEventToAdobeAnalytics('add_to_cart', { data: productAnalytics, prevCartCount });
    const loyaltyPayload = {
      respToProcess,
      lastProrduct,
      payload,
    };
    yield openAddedToBagModal(res, prevCartCount, callBack, loyaltyPayload, isOutfitsOnBag);
  } catch (errorObj) {
    const { error, errorProductId, atbSuccessProducts = [], respToProcess } = errorObj;
    const errorMapping = yield select(BagPageSelectors.getErrorMapping);
    const errMsg = getErrorMessage(error, errorMapping);

    if (atbSuccessProducts.length > 0) {
      const lastProrduct =
        (atbSuccessProducts && atbSuccessProducts[atbSuccessProducts.length - 1]) || {};
      const loyaltyPayload = {
        respToProcess,
        lastProrduct,
        payload,
      };
      yield openAddedToBagModal(
        atbSuccessProducts,
        prevCartCount,
        callBack,
        loyaltyPayload,
        isOutfitsOnBag,
        errMsg
      );
      if (isOutfitsOnBag) {
        yield put(AddToCartOutfitItemError(errMsg));
        yield put(setAddedToBagBtnLoader(false));
      } else {
        yield put(AddToCartMultipleItemError({ errMsg, errorProductId }));
      }
    } else {
      if (isFromPjPlanner) {
        yield put(SetAddedToBagData([...productItemsInfo]));
        yield put(openAddedToBag());
      }
      if (isOutfitsOnBag) {
        yield put(AddToCartOutfitItemError(errMsg));
        yield put(setAddedToBagBtnLoader(false));
      } else {
        yield put(AddToCartMultipleItemError({ errMsg, errorProductId }));
      }
      yield put(setLoaderState(false));
      logger.error('Error: Error in adding multi product to bag', {
        error: error || errorObj,
        extraData: {
          component: 'addMultipleItemToCartECOM Saga - AddedToBag.saga.js',
          payloadRecieved: payload,
        },
      });
    }
  }
}

export function* addMultipleItemToCartECOMSingleAPI(payload) {
  const { callBack, productItemsInfo, isFromPjPlanner } = payload;
  yield put(setLoaderState(true));
  yield put(setUnavailableProductIds(null));
  try {
    const prevCartCount = yield call(getCartItemCount, true);
    const extendedOrderValue = yield select(getExtendedPreOrderValue);

    const paramsArray = getPayloadArray(productItemsInfo, extendedOrderValue);
    yield put(clearAddToBagErrorState());
    yield put(setUnavailableProductIds(null));
    yield put(clearAddToCartFbtError());
    yield put(clearAddToCartMultipleItemErrorState());
    const errorMapping = yield select(BagPageSelectors.getErrorMapping);
    const res = yield call(
      addMultipleProductsInEcomNEWAPI,
      paramsArray,
      errorMapping,
      isFromPjPlanner
    );
    const unavailableProductIds = res?.basketError?.errorParameters?.PRODUCT_IDS?.split('|');
    let result;
    const isBasketError = res?.basketError;
    if (isBasketError) {
      result = productItemsInfo?.filter((item) =>
        unavailableProductIds?.includes(item.skuInfo.variantId)
      );
      const unvalObj = {
        products: result,
        error: res?.basketError,
      };
      const productIdsString = unvalObj?.error?.errorParameters?.PRODUCT_IDS;
      const atbUnavailableProductsArray = productIdsString && productIdsString.split('|');
      yield put(removeAddedProducts(atbUnavailableProductsArray));
      yield put(setUnavailableProductIds(unvalObj));
    }
    const { addToBasketResp } = res || {};
    const lastProrduct = { ...res, isFromPjPlanner } || {};
    const respToProcess = addToBasketResp;
    delete res.addToBasketResp;

    yield put(callItemInBag());
    const loyaltyPayload = {
      respToProcess,
      lastProrduct,
      payload,
    };
    const passCallback = !isBasketError ? callBack : null;
    yield openAddedToBagModal([lastProrduct], prevCartCount, passCallback, loyaltyPayload);
  } catch (error) {
    const productItemsInfoArray = [];
    if (isFromPjPlanner) {
      productItemsInfo.forEach((item) => {
        productItemsInfoArray.push({ ...item, isFromPjPlanner });
      });
      yield put(SetAddedToBagData([...productItemsInfoArray]));
      yield put(openAddedToBag());
    }
    const errorMapping = yield select(BagPageSelectors.getErrorMapping);
    const pageData = yield select(getPageData);
    const pageType = pageData && pageData.pageType;
    const errorObj = isFromPjPlanner ? error?.error?.[0] || {} : error;
    const errMsg = getErrorMessage(errorObj, errorMapping, pageType);
    yield put(AddToCartMultipleItemError({ errMsg }));
    yield put(setLoaderState(false));
    yield put(resetBagLoadingState());
  }
}

export function* multiAddToBagECOM({ payload }) {
  const isOutfitsOnBag = yield select(getIsOutfitsOnBag);

  if (!isOutfitsOnBag) yield put(updateAddToBagInProgress(true));
  const singleAddedToBagAPIEnabled = yield select(getIsSingleAddToBagAPIEnabled);
  if (singleAddedToBagAPIEnabled) {
    yield call(addMultipleItemToCartECOMSingleAPI, payload);
  } else {
    yield call(addMultipleItemToCartECOM, payload, isOutfitsOnBag);
  }
  yield put(updateAddToBagInProgress(false));
}

export function* sendUserBrowseHistory(payload) {
  yield call(saveUserbrowseSelectionApi, payload);
}

export function* AddedToBagSaga() {
  yield takeLatest(ADDEDTOBAG_CONSTANTS.ADD_TO_CART_ECOM, addToCartEcom);
  yield takeLatest(ADDEDTOBAG_CONSTANTS.ADD_TO_CART_BOPIS, addItemToCartBopis);
  yield takeLatest(ADDEDTOBAG_CONSTANTS.ADD_MULTIPLE_ITEMS_CART_ECOM, multiAddToBagECOM);
  yield takeLatest(ADDEDTOBAG_CONSTANTS.SAVE_USER_BROWSE_HISTORY, sendUserBrowseHistory);
}

export default AddedToBagSaga;
